<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
    <div
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="page-login"
    >
      <login-form title="Company" v-on:submit="login" :path="path" />
    </div>
  </b-overlay>
</template>

<script>
import Login from "../../../components/auth/Login";
export default {
  components: {
    "login-form": Login,
  },
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
      loginForm: {},
      path: "",
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
  created() {
    this.path = "/company/forgot-password";
  },
  methods: {
    /**
     * login_user method for Login form for company Login
     **/
    async login(val) {
      if (Boolean(val) == false) return;
      this.show = true;
      try {
        const res = await this.$store.dispatch("CompanyLogin", val);

        if (res.data.status == "warning") {
          this.$toasted.show(this.$t(res.data.message), {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
        } else {
          this.$toasted.show(this.$t("WelcomeToDashboard"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
          this.$store.dispatch("registerPusherBeam");
          let urlSlug = window.location.pathname.replace(
            /^\/([^\/]*).*$/,
            "$1"
          );
          localStorage.setItem("slug", urlSlug);
          if (this.$route.query.from) {
            this.$router.push(this.$route.query.from);
          } else {
            const routeVal = this.$store.getters.currentUser.is_unio
              ? "Company-dashboard"
              : "Company-walkin";
            this.$router.push({
              name: routeVal,
              params: { slug: urlSlug },
            });
          }
        }
      } catch (error) {
        this.$log.error(
          "File : /company/auth/Login.vue | Function : handleLogin() | Error :",
          error
        );
        // Error response
        this.error =
          this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
            ? this.$t(error.replace(/[\s\/]/g, ""))
            : error;
        this.$toasted.show(this.error, {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });
      }
      this.show = false;
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
